export const ROUTE_FAN_FEED_ROOT = '/fanfeed';
export const ROUTE_FAN_FEED_TAGS_ROOT = ROUTE_FAN_FEED_ROOT + '/tags';
export const ROUTE_FAN_FEED_TAGS_EDIT = ROUTE_FAN_FEED_TAGS_ROOT + '/edit/:id';
export const ROUTE_FAN_FEED_TAGS_NEW  = ROUTE_FAN_FEED_TAGS_ROOT + '/new';

export const ROUTE_FAN_FEED_POSTS_ROOT = ROUTE_FAN_FEED_ROOT + '/posts';
export const ROUTE_FAN_FEED_SLIDESHOW  = ROUTE_FAN_FEED_ROOT + '/posts/random_list';

export const ROUTE_FAN_FEED_POSTS_EDIT = ROUTE_FAN_FEED_POSTS_ROOT + '/:id';



// WEBPACK FOOTER //
// ./src/components/FanFeed/constants.ts